import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { AppModule } from './app/app.module';
import { BuildMode } from './environments/environment.base';
import { TratonPreset } from './traton-preset';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { providePrimeNG } from 'primeng/config';

if (environment.buildMode === BuildMode.PRODUCTION) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        applicationProviders: [
            provideZoneChangeDetection(),
            providePrimeNG({
                theme: {
                    preset: TratonPreset,
                    options: {
                        darkModeSelector: false,
                    },
                },
            }),
        ],
    })
    .catch((err) => console.error(err));
